import React from 'react';
import { useSelector } from 'react-redux';

/**
 * SidebarPermissionWrapper - Wraps sidebar menu items and only renders them if user has permission
 * @param {Object} props
 * @param {string} props.permission - The permission slug to check (e.g., 'dashboard', 'admin-list')
 * @param {React.ReactNode} props.children - The menu item component to render if permission exists
 */
const SidebarPermissionWrapper = ({ permission, children }) => {
    const permissions = useSelector((state) => state.auth.permissions || []);

    // Check if user has the required permission
    const hasPermission = permissions.some(perm => perm.slug === permission);

    // If no permission specified, show the item (for items that don't require permission check)
    if (!permission) {
        return <>{children}</>;
    }

    // Only render children if user has the required permission
    if (!hasPermission) {
        return null;
    }

    return <>{children}</>;
};

export default SidebarPermissionWrapper;

